module.exports = __webpack_public_path__ + "img/tv.fd79e12b.svg";